import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { DetailedProject as DetailedProjectModel } from 'api-client';
import { DetailedProject as DetailedProjectComponent, Loader, Section } from 'components';
import { createProjectProvider } from 'di';
import { useErrorCallback, useLoading } from 'hooks';

import { Container } from '../../../../../components';

import './DetailedProject.scoped.scss';

const DetailedProject = () => {
  const { uuid } = useParams();
  const errorCallback = useErrorCallback();
  const [loading, withLoading] = useLoading();
  const [project, setProject] = useState<DetailedProjectModel | null>(null);

  useEffect(() => {
    const callback = async () => {
      try {
        const provider = await createProjectProvider();
        const project = await provider.getOne(uuid!);
        setProject(project);
      } catch (err: any) {
        await errorCallback(err);
        setProject(null);
      }
    };
    (async () => {
      await withLoading(callback);
    })();
  }, []);
  return (
    <Container>
      <Section>
        {loading && <Loader />}
        {!loading && project === null && (
          <div className="detailed-project-page-fade-in">Проект не найден</div>
        )}
        {project && (
          <div className="detailed-project-page-fade-in">
            <DetailedProjectComponent project={project} />
          </div>
        )}
      </Section>
    </Container>
  );
};

export default DetailedProject;
